import store from "../store"
import router from "../router"
import Permissions from "../consts/Permissions"

function accessToRoute(to) {
	let resolved = router.resolve(to).route

	//console.log(`Checking route access to route ${resolved.path}`)
	if (!resolved.matched.some((val)=>{return val.meta.requiresAuth === true})) {
		//console.log(`Page does not require authentication.`)
		return true
	}
	if (!store.getters["user/isLoggedIn"]) {
		//console.error("Not logged in")
		return false
	}
	let user = store.state.user.user
	if (!user) {
		//console.log(`User object did not exist`)
		return false
	}
	if (!!resolved.meta?.product && user.products && !user.products.includes(resolved.meta.product)) {
		//console.error(`No product access! Users products: ${JSON.stringify(user.products)}, required product: ${resolved.meta.product}. is included = ${user.products.includes(resolved.meta.product)}`)
		return false
	}
	let noAccess = resolved.matched.some((val)=>{
		let resource = val.meta.resource || Permissions.Resource.Portal
		let operation = val.meta.operation || "R"
		if (!resource) {
			return false
		}
		if (!accessToOperation(resource, operation)) {
			//console.error("No Permission")
			return true
		}
	})
	if (noAccess) {
		return false
	}
	return true
}

function normalizeRoleIds(roles) {
	if (!Array.isArray(roles)) {
		return []
	}
	return roles.map((r) => {
		if (r != null && typeof r === "object") {
			return Number(r.id ?? r.ID)
		}
		return Number(r)
	}).filter((id) => !Number.isNaN(id))
}

function accessToOperation(resource, operation) {
	let user = store.getters["user/getUser"]
	if (!user) {
		return false
	}

	// NIS is Coordinator (118) / Auditor (119) only — no Platform Access / client roles.
	if (resource === Permissions.Resource.NIS) {
		const roles = normalizeRoleIds(user.roles)
		if (roles.includes(118)) {
			return true
		}
		if (roles.includes(119) && operation === "R") {
			return true
		}
		return false
	}

	let userPermissions = user.permissions
	let permissions = userPermissions && userPermissions[resource]
	if (!permissions) {
		return false
	}
	if (permissions[operation] !== 1) {
		return false
	}

	return true
}

export { accessToOperation, accessToRoute }